import { render, staticRenderFns } from "./LegacySocialRedirect.vue?vue&type=template&id=71c89acc&scoped=true"
import script from "./LegacySocialRedirect.vue?vue&type=script&lang=js"
export * from "./LegacySocialRedirect.vue?vue&type=script&lang=js"
import style0 from "./LegacySocialRedirect.vue?vue&type=style&index=0&id=71c89acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c89acc",
  null
  
)

export default component.exports